const FORM_LINK_CLICK_THROUGH_PREFIX = 'UserVisit.FormLinkClickThrough.';
const USER_VISIT_WIZARD_PREFIX = 'UserVisit.Wizard.';

export enum TMS_EVENT_TYPES {
  BillBoard = `${FORM_LINK_CLICK_THROUGH_PREFIX}BillBoard`,
  Header = `${FORM_LINK_CLICK_THROUGH_PREFIX}Header`,
  Hero = `${FORM_LINK_CLICK_THROUGH_PREFIX}Hero`,
  ProgramSelection = `${FORM_LINK_CLICK_THROUGH_PREFIX}ProgramSelection`,
  ProgramInfo = `${FORM_LINK_CLICK_THROUGH_PREFIX}ProgramInfo`,
  FormWizardView = `${USER_VISIT_WIZARD_PREFIX}View`,
  FormSubmit = `${USER_VISIT_WIZARD_PREFIX}FormSubmit`,
  FormWizardStarted = `${USER_VISIT_WIZARD_PREFIX}Started`,
  QuestionViewed = `${USER_VISIT_WIZARD_PREFIX}QuestionViewed`,
  QuestionAnswered = `${USER_VISIT_WIZARD_PREFIX}QuestionAnswered`,
  FormResume = `${USER_VISIT_WIZARD_PREFIX}Resume`,
  profileCreated = `${USER_VISIT_WIZARD_PREFIX}ProfileCreated`,
}

export enum GA_EVENTS_MAP {
  PAGE_VIEW = 'page_view',
  FORM_WIZARD_VIEW = 'form_wizard_view',
  FORM_WIZARD_STARTED = 'form_wizard_started',
  JF_FORM_WIZARD_STARTED = 'lead_start',
  QUESTION_VIEWED = 'question_viewed',
  QUESTION_ANSWERED = 'question_answered',
  FORM_SUBMIT = 'form_submit',
  JF_FORM_SUBMIT = 'lead_submit',
  FORM_MOVE_BACK = 'back_button_clicked',
  FORM_RESUME = 'resume_viewed',
  FORM_RESUME_SELECTION = 'resume_answered',
  AUDIENCE_GROUP = 'audience_group_assigned',
  PAGE_SECTION_VIEW = 'page_section_view',
  PROFILE_PAYABLE_USER = 'profile_payable_user',
  PROFILE_CREATED = 'profile_created',
  JF_PROFILE_CREATED = 'lead_midpoint',
  SECONDS_ON_PAGE = 'seconds_on_page',
  GENERIC_EVENT = 'ga_generic_event',
  USER_INITIAL_SCROLL = 'user_initial_scroll',
  CP_RESULTS_ACTION = 'school_listing_action',
  CP_CLICK_CONVERSION = 'click_portal_school_listing_click',
  CROSS_DOMAIN_CONVERSION = 'cross_domain_conversion',
  FLOODLIGHT_COUNT_EVENT = 'floodlight_counter_event',
  FLOODLIGHT_CONVERSION_EVENT = 'floodlight_conversion_event',
  MICROSOFT_PAGE_VIEW = 'microsoft_page_view',
  MICROSOFT_CONVERSION_EVENT = 'microsoft_conversion_event',
  SCHOOL_CARD_EXPANDED = 'school_card_expanded',
  CAROUSEL_INTERACTION = 'carousel_interaction',
  EXPERIMENT_VIEWED = 'experiment_viewed',
}

export const GA_TO_TMS_EVENT_MAP: { [__T in GA_EVENTS_MAP]?: TMS_EVENT_TYPES } =
  {
    [GA_EVENTS_MAP.FORM_WIZARD_VIEW]: TMS_EVENT_TYPES.FormWizardView,
    [GA_EVENTS_MAP.FORM_WIZARD_STARTED]: TMS_EVENT_TYPES.FormWizardStarted,
    // TODO: [T1-13584] disabling this until batch logevent is supported
    // [GA_EVENTS_MAP.QUESTION_VIEWED]: TMS_EVENT_TYPES.QuestionViewed,
    // [GA_EVENTS_MAP.QUESTION_ANSWERED]: TMS_EVENT_TYPES.QuestionAnswered,
    [GA_EVENTS_MAP.FORM_SUBMIT]: TMS_EVENT_TYPES.FormSubmit,
    [GA_EVENTS_MAP.FORM_RESUME]: TMS_EVENT_TYPES.FormResume,
    [GA_EVENTS_MAP.PROFILE_CREATED]: TMS_EVENT_TYPES.profileCreated,
  };
